export const API_ENDPOINT = {
  Login: {
    api: "/auth/v1/login",
    method: "POST",
  },
  Otp: {
    api: "/auth/v1/verifyOTP",
    method: "POST",
  },
  profile: {
    api: "/admin-api/v1/profile",
  },
  rolesAndPermissions: {
    supplierRolesApi: "/admin-api/v1/supplier-roles",
    rolesAndPermissionsApi: "/admin-api/v1/role-permissions"
  },
  adminUsers: {
    adminUsersApi: "/admin-api/v1/admin-users"
  },
  Company: {
    api: "/admin-api/v1/on-boarding",
    onboardingDetails: "/admin-api/v1/details",
    gstDetailsApi: "/admin-api/v1/billing",
  },
  Employee: {
    api: "/admin-api/v1/employee",
  },
  Car: {
    api: "/admin-api/v1/config-cars",
    companyCarApi: "/company/v2/car-types",
    facilitiesApi: "/admin-api/v1/config-cars",
    facilities:"/trip-api/v1/get-facilities"
  },
  RateCard: {
    api: "/company/v2/rate-cards",
    tripPriceApi:"/booking/v2/rate-estimates",
    companyLocation: '/company/v2/company-cities',
    companyDuty: '/company/v2/company-services',
    subCity:'/company/v1/sub-location',
    apiv2: "/company/v2/rate-cards",
    rateCardType: "/company/v2/rate-card-types",
  },
  DutyType: {
    api: "/company/v1/duty-type",
  },
  ServiceCity: {
    api: "/trip-api/v1/service-cities",
    City: "/company/v1/city",
    serviceRegion: "/trip-api/v1/service-regions",
    subVendorRegion: "/admin-api/v1/subvendor-serviceable-regions",
  },
  SubVendor: {
    api: "/admin-api/v1/sub-vendors",
    method: "GET",
    moreApi: "/admin-api/v1/sub-vendors/more-details",
  },
  Driver: {
    api: "/admin-api/v1/drivers",
    matrixApi: "/admin-api/v1/drivers/matrix",
    ticketApi: "/admin-api/v1/drivers/tickets",
    moreApi: "/admin-api/v1/drivers/more-details",
  },
  Vehicle: {
    api: "/admin-api/v1/company-vehicles",
    matrixApi: "/admin-api/v1/vehicle-matrix",
    moreApi: "/admin-api/v1/compliance-submission-values",
  },
  Dashboard: {
    registrationApi: "/admin-api/v1/total-rides",
    rideDetailsApi: "/admin-api/v1/dashboard-details",
    rideAnalyticApi: "/admin-api/v1/revenue-split",
    ourCustomerApi: "/admin-api/v1/our-daily-customers",
    ourCarApi: "/admin-api/v1/our-cars",
    cabRideApi: "/admin-api/v1/get-cab-ride-details",
    topVendorApi: "/admin-api/v1/get-top-vendor",
    topSubVendorApi: "/admin-api/v1/get-top-sub-vendor",
    topDriverApi: "/admin-api/v1/get-top-drivers",
    rideAcceptApi: "/admin-api/v1/ride-acceptance",
    dashboardFeedbackApi: "/admin-api/v1/get-feedback",
    topCompanies:'/admin-api/v1/top-companies',
    companyTripStats:'/admin-api/v1/company-trip-stats',
    companyData:'/admin-api/v1/contract-details'
  },

  Vendor: {
    api: "/admin-api/v1/vendors",
    user: "/admin-api/v1/vendors/users",
    method: "GET",
  },

  ConfigCompliance: {
    api: "/admin-api/v1/compliances",
    verificationApi: "/admin-api/v1/compliance-verifications",
  },
  OnBoardCompliance: {
    api: "/admin-api/v3/onboard-compliances",
    method: "GET",
  },

  ChooseYourService: {
    api: "/trip-api/v1/trip-services",
  },

  reservation: {
    bookingApi: "/trip-api/v3/reservations",
    reservationApi: "/trip-api/v3/b2b-trips",
    cancelReasonApi:"/trip-api/v1/cancel-reasons",
    bufferTimeApi: "/booking/v1/pre-reservation-time",
    extensionRequestApi: "/trip-api/v3/extension-request-action",
    provisionTripApi: "/trip-api/v3/provision-extension-trip",
    uploadTripAttachmentsApi: "/trip-api/v2/upload-tripAttachments",
    manageTripChargesApi: "/trip-api/v3/manage-b2b-trip-charges",
    retrievePaymentLinkApi: "/payment/v3/retrieve-payment-link",
    generatePaymentLinkApi: "/payment/v3/generate-payment-link"
  },

  operations: {
    allotApi: "/admin-api/v1/assign-driver",
    availableVehicleApi: "/admin-api/v1/driver-assigns",
    availableSuppliersApi: "/admin-api/v1/sub-vendor-driver-assigns",
    dispatchApi: "/trip-api/v1/dispatch/",
    cancelTrip: "/trip-api/v3/cancel-trips/",

    billing: {
      bookinginvoiceDetails: "/trip-api/v1/b2b-invoices",
      billingListApi: "/billing/v2/performa-invoices",
      billingPriceDetails: "/billing/v1/trip-prices",
      bookingChargesCalculationApi: "/billing/v1/extra-charges",
      billingConsolidatedInvoiceApi: "/billing/v1/consolidated-invoices",
      billingRequestForApproval: "/billing/v2/performa-invoice-approval-requests",
      consolidateInvoiceMatrixApi:"/billing/v2/consolidated-invoice-matrix",
      finalInvoiceApi:"/billing/v2/final-invoices",
      consolidateInvoiceDetailApi:"/billing/v2/consolidated-invoice-detail",
      billingRequestForApprovalLink: "/billing/v2/performa-invoice-approval-link",
    }
  },

  reports: {
    bookingReports: "/admin-api/v1/bookings-reports",
    bookingMatrixReports: "/admin-api/v1/booking-matrix",
    revenueReports:'/admin-api/v1/revenue-reports',
    revenueExportApi:"/admin-api/v1/",
    revenueMatrix:'/admin-api/v1/revenue-matrix',
    customerReport:'/admin-api/v1/employee-details',
    customerMatrix:'/admin-api/v1/employee-matrix',
    misRportApi: '/admin-api/v1/managementInfo',
  },

    GeneratedReport:{
    generatedReportApi: "/admin-api/v3/tasks/report"
  },

  GoogleMap: {
    autocompleteApi: "/trip-api/v1/auto-complete",
    nearbysearch: "/trip-api/v1/nearbySearch-api",
    placeApi: "/trip-api/v1/place-api",
    directionApi: "/trip-api/v1/direction-api",
    geocodeApi: "/geocode/json",
  },

  settlement: {
    api: "/billing/v1/settlements",
    consolidateInvoice:'/billing/v1/consolidated-invoices'
  },

  AssignVehicle: {
    requestVehicleApi: "/admin-api/v1/vehicle-list",
    listAssignedVehicleApi: "/admin-api/v1/assigned-vehicle-list",
    assignVehicleApi: "/admin-api/v1/assign-vehicle",
    assignDriverApi: "/admin-api/v1/assign-driver",
    assignSubVendorApi: "/admin-api/v1/assign-subvendor",
  },

  Trip: {
    assignDriverApi: "/admin-api/v1/driver-assigns",
  },

  magicToken: {
    createMagicToken:"/auth/v1/magic-token",
    verifyMagicToken:"/auth/v1/magic-token/verify"
  },

  Logout:{
    api:"/auth/v1/logout"
  },

  Compliance: {
    api: "/admin-api/v1/compliance-submissions",
    method: "GET",
    complianceRegex: "/admin-api/v1/compliance-validations"
  },

  ReUploadCompliance: {
    api: "/admin-api/v3/compliance-resubmit",
    method: "POST",
  },

  AdminUser:{
    api:"/admin-api/v1/admin-users"
  },

  Tag:{
    api:"/admin-api/v1/tags"
  },
  Rating:{
    api:"/admin-api/v1/ratings"
  },
  Faq:{
    api:"/admin-api/v1/faqs",
    sectionApi:"/admin-api/v1/faq-sections",
    subSectionApi: "/admin-api/v1/faq-sub-sections"
  },
  ParentCompanyDetails:{
    api:"/admin-api/v1/parent-details",
  },
  MapApi:{
    api:"https://maps.googleapis.com/maps/api/"
  },
  liveTrips:{
    api:"/livetrip-api/v1/trip"
  },
  Notification:{
    api:"/admin-api/v1/notification",
    countApi:"/admin-api/v1/notification/count",
    seenApi:"/admin-api/v1/notification/seen"
  },
  CountryList: {
    api: "/auth/v1/getCountryList"
  },
   Customer:{
    api:"/company/v1/employee-profile",
    matrixApi:"/admin-api/v1/customers/matrix",
    ticketApi:"/admin-api/v1//customers/tickets",
  },
  CustomerComplaints:{
    api:"/trip-api/v2/complains",
    apiById:"/trip-api/v2/complain",
    updateComplainApi: "/trip-api/v2/updateComplain",
  },
   couponApi:{
    getApi:"/admin-api/v1/coupons",
    addCoupon:"/admin-api/v1/coupons",
    update:"/admin-api/v1/coupons",
    status: '/admin-api/v1/coupons/status',
    delete:"/admin-api/v1/coupons",
  },
};
